import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

import Link from '../components/link';

const repositories = [
  {
    text: 'Hacker News app built with Gatsby.',
    url: 'https://github.com/emmafallancy/hnpwa-gatsby'
  },
  {
    text: 'Chimerical, a dashboard like web app.',
    url: 'https://github.com/emmafallancy/chimerical-partner-node',
  },
  {
    text: 'And more in my Github repositories.',
    url: 'https://github.com/emmafallancy?tab=repositories'
  }
];

const contributions = [
  {
    text: 'Gatsby',
    url: 'https://github.com/gatsbyjs/gatsby/commits?author=emmafallancy',
  },
  {
    text: 'React website',
    url: 'https://github.com/reactjs/reactjs.org/commits?author=emmafallancy'
  },
  {
    text: 'Next.js Starter Project',
    url: 'https://github.com/iaincollins/nextjs-starter/commits?author=emmafallancy',
  },
  {
    text: 'Glamorous website',
    url: 'https://github.com/kentcdodds/glamorous-website/commits?author=emmafallancy',
  }
];

const ProjectLink = ({url, text}) =>
  <p
    css={{
      fontSize: '1.8rem',
      lineHeight: '1.45',
      margin: '0 0 1.5rem',
    }}
  >
    <Link
      to={url}
      css={{
        color: '#000000',
        fontSize: '1.8rem',
        borderBottom: '2px dashed #25ced1',
        textDecoration: 'none',
      }}
    >
      {text}
    </Link>
  </p>;

const About = () =>
  <div
    css={{
      margin: '0 auto 2rem',
      maxWidth: '960px',
      padding: '0 2rem',
    }}
  >
    <Helmet
      title="🎉 About - Emmanuel Fallancy"
      meta={[
        {
          name: 'description',
          content: 'Get to know who and what is Emmanuel into nowadays.'
        },
        {
          name: 'keywords',
          content: 'efallancy, Emmanuel Fallancy, emmanuel fallancy'
        },
      ]}
    />
    <header
      css={{
        padding: '0 1rem',
        textAlign: 'center',
        margin: '0 auto',
        maxWidth: '300px'
      }}
    >
      <h1
        css={{
          position: 'relative',
          padding: '1rem 0',
          '&::before': {
            content: '""',
            backgroundColor: 'rgba(37, 206, 209, 0.65)',
            position: 'absolute',
            top: '0',
            left: '0',
            transform: 'skew(-20deg)',
            width: '100%',
            height: '100%',
            zIndex: '-1',
          }
        }}
      >
        Hi there!
      </h1>
    </header>
    <main
      css={{
        margin: '0 auto',
        maxWidth: '480px',
      }}
    >
      <p
        css={{
          fontSize: '1.8rem',
          textAlign: 'center',
        }}
      >
        I am <b>Emmanuel Fallancy</b>. A web developer based in Sydney. Love learning, open source enthusiast, and enjoys having (strong) coffee.
      </p>
    </main>
    <div
      css={{
        display: 'flex',
        width: '100%',
        '@media (max-width: 767px)': {
          flexWrap: 'wrap'
        }
      }}
    >
      <div
        css={{
          background: '#fffffc',
          border: '1px solid #25ced1',
          boxShadow: '0 5px 5px 0 rgba(0,0,0,0.50)',
          borderRadius: '5px',
          display: 'inline-block',
          marginRight: '0.5rem',
          padding: '2rem 1.5rem',
          width: 'calc(100% / 2)',
          '@media (max-width: 767px)': {
            display: 'block',
            width: '100%',
            marginRight: '0',
            marginBottom: '2rem'
          }
        }}
      >
        <h3
          css={{
            fontSize: '2.4rem',
            margin: '0 0 2rem',
          }}
        >
          Some of the few tech(s) that I use in my adventure as developer.
        </h3>
        <p
          css={{
            fontSize: '1.8rem',
            lineHeight: '1.45',
            margin: '0 0 1rem'
          }}
        >
          🏁 Using NodeJS for most of my work while exploring Rust, Clojure and Go.
        </p>
        <p
          css={{
            fontSize: '1.8rem',
            lineHeight: '1.45',
            margin: '0 0 1rem'
          }}
        >
          ⚛️ Spend most of my time in React and juggling with Vue at the same time.
        </p>
        <p
          css={{
            fontSize: '1.8rem',
            lineHeight: '1.45',
            margin: '0 0 1rem'
          }}
        >
          🎯 Oftenly with Gatsby and Next.js when it comes to framework.
        </p>
        <p
          css={{
            fontSize: '1.8rem',
            lineHeight: '1.45',
            margin: '0 0 1rem'
          }}
        >
          📡 Into GraphQL and suprisingly convinced myself to build GraphQL server for managing sitemap.
        </p>
        <p
          css={{
            fontSize: '1.8rem',
            lineHeight: '1.45',
            margin: '0 0 1rem'
          }}
        >
          📊 Either PostgresQL or MongoDB but preferably, CMS like services wherever JAMStack is possible.
        </p>
        <p
          css={{
            fontSize: '1.8rem',
            lineHeight: '1.45',
            margin: '0 0 1rem'
          }}
        >
          📐 Sketch as my weapon of choice for wireframing and prototyping.
        </p>
        <p
          css={{
            fontSize: '1.8rem',
            lineHeight: '1.45',
            margin: '0 0 1rem'
          }}
        >
          💻 Using Hyper as my terminal.
        </p>
      </div>
      <div
        css={{
          background: '#fffffc',
          border: '1px solid #25ced1',
          boxShadow: '0 5px 5px 0 rgba(0,0,0,0.50)',
          borderRadius: '5px',
          display: 'inline-block',
          marginLeft: '0.5rem',
          padding: '2rem 1.5rem',
          width: 'calc(100% / 2)',
          '@media (max-width: 767px)': {
            display: 'block',
            width: '100%',
            marginLeft: '0'
          }
        }}
      >
        <div
          css={{
            margin: '0 0 4rem',
          }}
        >
          <h3
            css={{
              fontSize: '2.4rem',
              margin: '0 0 2rem',
            }}
          >
            Things I made
          </h3>
          {
            repositories.map(({text, url}, index) =>
              <ProjectLink text={text} url={url} key={index} />
            )
          }
        </div>
        <div
          css={{
            margin: '0 0 4rem',
          }}
        >
          <h3
            css={{
              fontSize: '2.4rem',
              margin: '0 0 2rem',
            }}
          >
            Projects I contributed to
          </h3>
          {
            contributions.map(({text, url}, index) =>
              <ProjectLink text={text} url={url} key={index} />
            )
          }
        </div>
      </div>
    </div>
  </div>;

export default About;


// WEBPACK FOOTER //
// ./src/pages/about.js